// Страница дашборда студента: управляет онбордингом и отображает компонент StudentDashboard с данными профиля.

import { useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import AppNavbar from '../../components/common/AppNavbar';
import StudentOnboarding from '../../components/students/StudentOnboarding';
import StudentDashboard from '../../components/students/StudentDashboard';
import useAuthStore from '../../store/authStore';
import { getStudentProfile, getStudentHistory } from '../../api/studentApi';

export default function StudentDashboardPage() {
  const { user, token, fetchMe } = useAuthStore();
  const isGuest = !token;

  const [profileLoading, setProfileLoading] = useState(!isGuest);
  const [showOnboarding, setShowOnboarding] = useState(false);
  const [studentLevel, setStudentLevel] = useState(null);

  const [incompleteCount, setIncompleteCount] = useState(0);
  const [loadingCount, setLoadingCount] = useState(!isGuest);

  // Для гостей профиль не загружаем
  useEffect(() => {
    if (isGuest) return;
    const checkProfile = async () => {
      try {
        if (!user) await fetchMe();
        const { data } = await getStudentProfile();

        const skipped = localStorage.getItem('ewl_onboarding_skipped') === 'true';
        setShowOnboarding(!data?.profile_filled && !skipped);

        // Уровень студента из профиля
        const level =
          data?.complexity_level?.name ??
          data?.complexity_level_name ??
          null;
        setStudentLevel(level);
      } catch {
        setShowOnboarding(false);
      } finally {
        setProfileLoading(false);
      }
    };
    checkProfile();
  }, []);

  // Загружаем незавершённые упражнения (только для авторизованных)
  useEffect(() => {
    if (isGuest) return;
    const fetchIncomplete = async () => {
      try {
        const { data } = await getStudentHistory(20, 0);
        const count = Array.isArray(data)
          ? data.filter((h) => h.status === 0).length
          : 0;
        setIncompleteCount(count);
      } catch {
        setIncompleteCount(0);
      } finally {
        setLoadingCount(false);
      }
    };
    fetchIncomplete();
  }, []);

  const handleOnboardingComplete = () => {
    setShowOnboarding(false);
  };

  const handleOnboardingSkip = () => {
    localStorage.setItem('ewl_onboarding_skipped', 'true');
    setShowOnboarding(false);
  };

  // Показываем онбординг
  if (showOnboarding && !profileLoading) {
    return (
      <>
        <AppNavbar />
        <StudentOnboarding
          onComplete={handleOnboardingComplete}
          onSkip={handleOnboardingSkip}
        />
      </>
    );
  }

  // Загрузка профиля
  if (profileLoading) {
    return (
      <>
        <AppNavbar />
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: 'calc(100vh - 56px)' }}>
          <Spinner animation="border" variant="primary" />
        </div>
      </>
    );
  }

  return (
    <>
      <AppNavbar />
      <StudentDashboard
        user={user}
        studentLevel={studentLevel}
        incompleteCount={incompleteCount}
        loadingCount={loadingCount}
        isGuest={isGuest}
      />
    </>
  );
}
